import { FeatureFlagUser } from '@/types';
import { PersistentStorageService } from '@/utils/services';

const DEFAULT_FEATURE_FLAG_USER: FeatureFlagUser = {
  userId: window.crypto.randomUUID(),
};

/**
 * When called, this function will look for a value in the backing store for the
 * "featureFlagUser" key. If found it will return that value. If not found, it will
 * initialize a default feature flag user setup and store it in the backing store.
 *
 * @return {*}  {UserInfo}
 */
export const generateFeatureFlagUser = (
  defaultUser: FeatureFlagUser = DEFAULT_FEATURE_FLAG_USER
) => {
  const storedUser = PersistentStorageService.getFeatureFlagUser();
  const user = storedUser ?? defaultUser;

  if (!storedUser) {
    PersistentStorageService.setFeatureFlagUser(defaultUser);
  }

  return user;
};
